import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";

export const Wrapper = styled.section`
  min-height: 80vh;
  border-radius: 5px;
  padding: 20px;
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
`;

export const EmptyContainer = styled.div`
  border-radius: 5px;
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  width: 100%;
  padding: 100px 0;
  gap: 20px;
  color: ${({ theme }) =>
    theme.value === "light" ? COLORS.BLACK : COLORS.WHITE}60;
  text-align: center;
  b {
    display: block;
    padding-bottom: 15px;
    font-weight: 600;
  }
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.COLORS.WHITE};
  font-weight: 500;
  font-size: ${calcRem(24)};
  margin-bottom: 20px;
`;

export const FormItem = styled.div`
  padding-bottom: 20px;
`;

export const Item = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 10px;
  font-size: ${calcRem(14)};
  color: ${({ theme }) => theme.COLORS.WHITE};
  a {
    color: ${({ theme }) => theme.COLORS.BUTTONS2};
  }
  small {
    color: ${COLORS.BUTTONS1};
  }
`;
